import 'css-chunksrc/client/pages/workloadPage/table/loader/row/styles.scss';export default {
  "row": "_row_13pgu_1",
  "resourceCell": "_resourceCell_13pgu_6",
  "chevronBox": "_chevronBox_13pgu_22",
  "avatar": "_avatar_13pgu_27",
  "identity": "_identity_13pgu_34",
  "name": "_name_13pgu_41",
  "cell": "_cell_13pgu_46",
  "cellBar": "_cellBar_13pgu_58"
};